import m from 'mithril'

export default {
  view: vnode => {
    const laika = require('./laika.jpg')
    const monkey = require('./monkey.jpg')
    const gagarin = require('./gagarin.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-08-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">
          Rumkapløbet 
          </h3>
          <p className="log-book-text">
          Den Kolde Krig er næret af et tæt kapløb mellem USA og Sovjet. USA er presset og føler sig bagud på flere fronter. Det handler ikke kun om våben og militær, men også om kampen om Rummet. 
          </p>

          <ul className="log-book-text">
            <li>Den 4. oktober 1957 sender Sovjet den første raket i kredsløb om Jorden - Sputnik 1. </li>
            <li>Den 3. november 1957 får hunden Laika en tur i Rummet i Sputnik 2. </li>
            <li>Den 31. januar 1961 svarer amerikanerne igen og sender aben Ham på rumfart. </li>
            <li>Den 12. april 1961 sender Sovjet det første menneske i Rummet.</li>
          </ul>          

          <figure className="log-book-figure">
            <img src={laika} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Her er Laika portrætteret på et rumænsk frimærke. 
            </figcaption>
          </figure>

          <figure className="log-book-figure">
            <img src={monkey} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Her får Ham et håndtryk af en amerikansk kommandør.
            </figcaption>
          </figure>

          <figure className="log-book-figure">
            <img src={gagarin} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Jurij Gagarin - det første menneske i rummet.
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
